export function getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
    return match ? decodeURIComponent(match[2]?match[2]:"") : null
}

export function setCookie(name: string, value: string, days = 7) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString()
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; expires=${expires}`
}

export function eraseCookie(name: string) {
    document.cookie = `${name}=; Max-Age=0; path=/;`
}
